module.exports = __webpack_public_path__ + "img/ola.007decf3.png";